<template>
  <inner-menu-layout :menu="accountRoutes" />
</template>

<script>
import InnerMenuLayout from './Index.vue';

export default {
  name: 'AccountLayout',
  components: {
    InnerMenuLayout,
  },
  data() {
    return {
      accountRoutes: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.setRoutes();
    },
    setRoutes() {
      const routes = this.$router.options.routes.find(item => item.name === 'Account');
      if (routes && routes.children && routes.children.length) {
        this.accountRoutes = routes.children;
      }
    },
  },
};
</script>
